import { render, staticRenderFns } from "./shopStoreBuyerLevel.vue?vue&type=template&id=b34f1194&"
import script from "./shopStoreBuyerLevel.vue?vue&type=script&lang=js&"
export * from "./shopStoreBuyerLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports